import React, { useCallback } from 'react'
import SignatureBanner from '../../components/SignatureBanner'
import MyContentsComponent from './components/MyContentsComponent'
import HomeHeader from '../../components/HomeHeader'
import Footer from '../../components/Footer'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/modules/rootReducer'
import HelpButton from '../../components/HelpButton'
import Sidebar from '../../components/SideBar'
import ContentLoader from 'react-content-loader'
import CanInterest from '../../components/CanInterest'

// component for banner promotional:
import CampaignBanners from '../../components/CampaignBanners'
import JoyrideHome from 'pages/Home/components/JoyrideHome'
import { useGetBanners } from 'pages/Home/hooks/use-get-banners'

// const CampaignEndDate = new Date('2023-09-04 07:50:59')

const MyContents: React.FC = () => {
  const { showHomeGuide } = useSelector((state: RootState) => state.showGuide)
  const { subscriptions, status: subscriptionStatus } = useSelector(
    (state: RootState) => state.subscription
  )
  const { isDarkMode } = useSelector((state: RootState) => state.theme)
  const learningCourses = useSelector((state: RootState) => state.learningCourses)

  const isSubscription = subscriptions.length > 0

  const swrBanners = useGetBanners()
  const banners = swrBanners.isLoading ? false : swrBanners.data

  const detectMob = useCallback(() => {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ]

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem)
    })
  }, [])

  const isMobile = detectMob()

  const LoaderProps = {
    speed: 2,
    backgroundColor: isDarkMode ? '#222222' : '#bababa',
    foregroundColor: isDarkMode ? '#2b2b2b' : '#dedede',
  }

  return (
    <>
      <Sidebar />
      <HomeHeader />
      {showHomeGuide && <JoyrideHome isDarkMode={isDarkMode} isMobile={isMobile} />}
      {banners && <CampaignBanners banner={banners} />}
      {subscriptionStatus === 'success' && !isSubscription && !banners && <SignatureBanner />}

      {learningCourses.status === 'loading' ? (
        <ContentLoader width={'80%'} height={500} viewBox={'0 0 100% 100%'} {...LoaderProps}>
          <rect x="300" y="20" rx="9" ry="9" width="80%" height="400" />
        </ContentLoader>
      ) : (
        <MyContentsComponent />
      )}
      {!isSubscription ? <CanInterest /> : <div />}
      <HelpButton />
      <Footer />
    </>
  )
}

export default MyContents
